import React, { useContext, useEffect, useRef, useState } from 'react'
import './InfoCube.css'
import { TikiaContext } from '../doit/Tikia';
import { RxDragHandleDots1 } from "react-icons/rx";

export default function InfoCube({front, back, top, bottom, left, right, wallSize, wallWidth, isEdit=false, onEdit}) {
  const FRONT = 'front';
  const BACK  = 'back';
  const LEFT  = 'left';
  const RIGHT = 'right';
  const TOP   = 'top';
  const BOTTOM= 'bottom';

  const {cubeReset, keyPressed} = useContext(TikiaContext);
  const resetRef = useRef(cubeReset);

  // TODO: Verify we need this...
  const [facing, setFacing] = useState(FRONT);

  const [editMode, setEditMode] = useState(isEdit);

  const [rX, setRx] = useState(0);
  const [rY, setRy] = useState(0);
  const [rZ, setRz] = useState(0);
  const [tZ, setTz] = useState(0);
  const [tX, setTx] = useState(0);
  const [tY, setTy] = useState(0);


  // "facing" NOT USED! WHAT'S IT FOR?
  //
  // ---[  EFFECT  ]---   [ cubeReset ]
  useEffect(()=>{        
    const resetMe = ()=> {
      setRx(0);
      setRy(0);
      setRz(0);
      
      setTz(0);
      setTx(0);
      setTy(0);
    }

    if(cubeReset !== resetRef.current || facing === FRONT) {
      resetRef.current = cubeReset;
      resetMe();
    }
  },[cubeReset, facing]);


  useEffect(()=>{
    if (isEdit && keyPressed) {
      console.log('InfoCube effect keyPressed: %s', keyPressed);
      
      if (keyPressed === 'ArrowLeft') {
        setTz(p => p + 12);
      }
      else if (keyPressed === 'ArrowRight') {
        setTz(p => p -12);
      }
      else if (keyPressed === 'ArrowUp') {
        setTy(p => p + 12);
      }
      else if (keyPressed === 'ArrowDown') {
        setTy(p => p -12); 
      }

    }
  }, [keyPressed, isEdit]);

  // ---[  EFFECT  Facing  ]---
  //
  useEffect(()=>{
    if (facing) {
      switch (facing) {
        case FRONT:   showFront();  break;
        case LEFT:    showLeft();   break;
        case RIGHT:   showRight();  break;
        case TOP  :   showTop();    break;
        case BOTTOM:  showBottom(); break;
        case BACK :   showBack();   break;

        default:
          console.error('Unknown Facing Value: %s', facing);
          break;
      }
    }

  }, [facing]);  

  // ---[  EFFECT  ]---  isEdit
  //
  useEffect(()=>{
    setEditMode(isEdit);
    if (isEdit) {
      setRz(15);
      setRy(-5);
    }
  }, [isEdit]);

  const turnRight = (e) => {
    e.preventDefault();
    setRy(rY => rY % 360 +90);
    setRx(pX => -pX);
    setRz(pZ => -pZ);
  }

  const turnLeft = (e) => {
    e.preventDefault();
    setRy(rY => rY % 360 -90);
    setRx(pX => -pX);
    setRz(pZ => -pZ);
  }


  const takeOut = (e) => {
    e.stopPropagation();
    onEdit();
  }

  const showFront = () => {
    setRx(0);
    setRy(0);
    setRz(0);
  }

  const showLeft = () => {
    setRx(0);
    setRy(60);
    setRz(0);
  }

  const showRight = () => {
    setRx(0);
    setRy(-60);
    setRz(0);
  }

  const showTop = () => {
    setRx(-60);
    setRy(0);
    setRz(0);
  }

  const showBottom = () => {
    setRx(+60);
    setRy(0);
    setRz(0);
  }

  const showBack = () => {
    setRx(-5);
    setRy(180);
    setRz(0);
  }

  // --- On Scroll ---
  //
  const onScroll = (e) => {
    //setTz(prev => Math.min(Math.max(prev + e.deltaY * 3.0, -400), 800));
    // if (kbdRef.current['Shift']) {
    //   setRy(prev => prev - e.deltaY * 0.4)
    // }
    setRx(prev => prev - e.deltaY * 0.5);
  }


  const isDebugOn = false;
  const withDebug = isDebugOn ? 'withDebug' : '';
  const iqFaceCtrl = `iqFaceCtrl ${withDebug}`
  const iqFaceTop = `iqFaceTop ${withDebug}`
  const iqFaceCenter = `iqFaceCenter ${withDebug}`
  const iqFaceLeft = `iqFaceLeft ${withDebug}`
  const iqFaceRight = `iqFaceRight ${withDebug}`
  const iqFaceBottom = `iqFaceBottom ${withDebug}`

  return (
    <div className='doubleSide' onClick={turnLeft} onContextMenu={turnRight} onWheel={onScroll}>
        <div className='dblScene' style={{
                                          width: `${2*wallSize}px`,
                                          height:`${2*wallSize}px`,
                                          transform: `translateZ(${tZ}px) translateX(${tX}px) translateZ(${tY}px)`
                                         }}>

          <div className='dblBox' style={{ 
                                          transform: `rotateY(${rY}deg) rotateX(${rX}deg) rotateZ(${rZ}deg)` 
                                         }}>
            
            
            <div className='dblFace dblFront' style={{ 
                                                        transform: `rotateY(0deg) translateZ(${wallWidth}px)`, 
                                                        fontSize: wallSize/6,
                                                        border:  editMode ? '4px solid orange' : '1px solid rosybrown' 
                                                     }}>

              <div className={iqFaceCtrl}>
                <div className={iqFaceTop} />            
                <div className={iqFaceBottom} onClick={takeOut}> 
                  <div className='drawerButton'>
                    <div className='drawerKnob'>
                      <RxDragHandleDots1/>
                    </div>                    
                    <div className='drawerKnob'>
                      <RxDragHandleDots1/>
                    </div>                    
                    <div className='drawerKnob'>
                      <RxDragHandleDots1/>
                    </div>                    
                    <div className='drawerKnob'>
                      <RxDragHandleDots1/>
                    </div>                    
                    <div className='drawerKnob'>
                      <RxDragHandleDots1/>
                    </div>                    
                  </div>
                </div>
              </div>

              {front}
              
            </div>

            <div className='dblFace dblBack'    style={{ 
                                                        transform: `rotateY(180deg) translateZ(${wallWidth}px)` 
                                                       }}>{back}</div>
            
            <div className='dblFace dblRight'   style={{
                   transform: `rotateY(90deg)  translateZ(${2*wallSize-wallWidth}px) `,
                   width: `${2*wallWidth}px`,
                   height: `${2*wallSize}px`
                 }} 
              // onClick={pushRight}
              >
              {right}
            </div>
            <div className='dblFace dblLeft'    
                 style={{ 
                   transform: `rotateY(-90deg)  translateZ(${wallWidth}px)`,
                   width: `${2*wallWidth}px`,
                   height: `${2*wallSize}px`
                  }} 
                  // onClick={pushLeft}
                  >
              {left}
            </div>
            <div className='dblFace dblTop'     
                 style={{ 
                   transform: `rotateX(90deg)   translateZ(${wallWidth}px)` , 
                   width: `${2*wallSize}px`,
                   height: `${2*wallWidth}px`
                 }} 
                //  onClick={pushBottom}
                 >
              {top}
            </div>
            <div className='dblFace dblBottom'  
                style={{ 
                  transform: `rotateX(-90deg)  translateZ(${2*wallSize-wallWidth}px)`, 
                  height: `${wallWidth*2}px` 
                }} 
                // onClick={pushTop}
                >
                  {bottom}
            </div>
          </div>
        </div>
    </div>
  )
}
